module.exports = __webpack_public_path__ + "img/rajput-qr.ee6cd7d6.png";